// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__S1bxn","navbarWrapper":"Navbar_navbarWrapper__m4wjS"};